<template>
  <v-container fluid class="pa-0">
    <div class="d-flex justify-space-between align-center flex-wrap">
      <div>
        <h2 class="subheading grey--text">Votaciones</h2>
        <p class="grey--text text--darken-1 mb-0">{{ counts.Abierta }} abierta · {{ counts.Pendiente }} pendiente · {{ counts.Aprobada + counts.Rechazada }} cerradas</p>
      </div>
      <v-btn color="primary" @click="dialogCreate = true"><v-icon left>mdi-plus</v-icon>Nueva votación</v-btn>
    </div>

    <v-card class="elevation-2 mt-4">
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <v-data-table
        :headers="headers"
        :items="votaciones"
        :footer-props="{
          itemsPerPageOptions: [{text: '5', value: 5}, {text: '10', value: 10}, {text: 'Todos', value: -1}],
          itemsPerPageText: 'Filas por página'
        }"
        :no-data-text="'No hay votaciones registradas'"
        class="elevation-0"
      >
        <template v-slot:item.tema="{ item }">
          <div class="font-weight-medium text-wrap" style="max-width: 320px;">{{ item.tema }}</div>
        </template>
        <template v-slot:item.progreso="{ item }">
          <div class="vote-progress">
            <div class="vote-seg" style="background:#43A047" :style="{ width: pct(item, 'A favor') + '%' }"></div>
            <div class="vote-seg" style="background:#E53935" :style="{ width: pct(item, 'En contra') + '%' }"></div>
            <div class="vote-seg" style="background:#9E9E9E" :style="{ width: pct(item, 'Abstención') + '%' }"></div>
            <div class="vote-seg" style="background:#EEEEEE" :style="{ width: pct(item, 'Pendiente') + '%' }"></div>
          </div>
          <div class="caption grey--text mt-1">{{ countVotes(item, 'A favor') }} a favor · {{ countVotes(item, 'En contra') }} en contra</div>
        </template>
        <template v-slot:item.estado="{ item }">
          <v-chip small :color="estadoColor(item.estado)" text-color="white">{{ item.estado }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="openDetail(item)">mdi-eye-outline</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" scrollable max-width="620">
      <v-card v-if="selected" class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title class="text-truncate">{{ selected.tema }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-chip small :color="estadoColor(selected.estado)" text-color="white" class="mr-2">{{ selected.estado }}</v-chip>
          <v-chip small outlined>Cierra: {{ selected.fechaCierre }}</v-chip>
          <p class="grey--text text--darken-2 mt-4">{{ selected.descripcion }}</p>

          <div class="vote-progress" style="height: 14px;">
            <div class="vote-seg" style="background:#43A047" :style="{ width: pct(selected, 'A favor') + '%' }"></div>
            <div class="vote-seg" style="background:#E53935" :style="{ width: pct(selected, 'En contra') + '%' }"></div>
            <div class="vote-seg" style="background:#9E9E9E" :style="{ width: pct(selected, 'Abstención') + '%' }"></div>
            <div class="vote-seg" style="background:#EEEEEE" :style="{ width: pct(selected, 'Pendiente') + '%' }"></div>
          </div>

          <v-row class="mt-3 text-center" dense>
            <v-col cols="3">
              <div class="dot" style="background:#43A047"></div>
              <div class="title font-weight-bold">{{ countVotes(selected, 'A favor') }}</div>
              <div class="caption grey--text">A favor</div>
            </v-col>
            <v-col cols="3">
              <div class="dot" style="background:#E53935"></div>
              <div class="title font-weight-bold">{{ countVotes(selected, 'En contra') }}</div>
              <div class="caption grey--text">En contra</div>
            </v-col>
            <v-col cols="3">
              <div class="dot" style="background:#9E9E9E"></div>
              <div class="title font-weight-bold">{{ countVotes(selected, 'Abstención') }}</div>
              <div class="caption grey--text">Abstenciones</div>
            </v-col>
            <v-col cols="3">
              <div class="dot" style="background:#CFD8DC"></div>
              <div class="title font-weight-bold">{{ countVotes(selected, 'Pendiente') }}</div>
              <div class="caption grey--text">Pendientes</div>
            </v-col>
          </v-row>

          <div class="overline grey--text mt-4 mb-1">Participantes</div>
          <v-list dense>
            <v-list-item v-for="(voto, name) in selected.votos" :key="name">
              <v-avatar size="28" color="green lighten-4" class="mr-3">
                <span class="caption green--text text--darken-3 font-weight-bold">{{ initials(name) }}</span>
              </v-avatar>
              <v-list-item-content>{{ name }}</v-list-item-content>
              <v-list-item-action>
                <v-chip x-small :color="estadoColor(voto)" text-color="white">{{ voto }}</v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialog = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="selected.estado === 'Abierta'" outlined color="primary" @click="cerrarVotacion()">Cerrar votación</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCreate" max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Nueva Votación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCreate = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-form>
            <v-text-field
              v-model="newVotacion.tema"
              label="Tema de la votación"
              placeholder="Ej: Aprobación de presupuesto"
              outlined
              dense
              class="mb-4"
              required
            ></v-text-field>

            <v-textarea
              v-model="newVotacion.descripcion"
              label="Descripción (opcional)"
              placeholder="Detalles sobre la votación..."
              outlined
              dense
              rows="3"
              class="mb-4"
            ></v-textarea>

            <v-text-field
              v-model="newVotacion.fechaCierre"
              label="Fecha de cierre"
              type="date"
              outlined
              dense
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogCreate = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="crearVotacion()"
            :loading="loadingCreate"
            :disabled="!newVotacion.tema || !newVotacion.fechaCierre || loadingCreate"
          >
            Crear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import votacionesService, { extractApiErrorMessage } from '@/services/votacionesService'
import { estadoColor, initials } from './mesaDirectivaMockData'

export default {
  name: 'MesaDirectivaVotaciones',
  data () {
    return {
      votaciones: [],
      dialog: false,
      dialogCreate: false,
      selected: null,
      loading: false,
      loadingCreate: false,
      newVotacion: {
        tema: '',
        descripcion: '',
        fechaCierre: ''
      },
      headers: [
        { text: 'Tema', value: 'tema' },
        { text: 'Progreso', value: 'progreso', sortable: false },
        { text: 'Estado', value: 'estado' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ]
    }
  },
  computed: {
    counts () {
      const c = { Abierta: 0, Pendiente: 0, Aprobada: 0, Rechazada: 0 }
      this.votaciones.forEach(v => { if (c[v.estado] !== undefined) c[v.estado]++ })
      return c
    }
  },
  async mounted () {
    console.log('Token:', this.$store.getters.getToken)
    console.log('Store:', this.$store)
    await this.loadVotaciones()
    console.log('Votaciones cargadas:', this.votaciones)
  },
  methods: {
    estadoColor,
    initials,
    async loadVotaciones () {
      this.loading = true
      try {
        this.votaciones = await votacionesService.getVotaciones()
      } catch (error) {
        const message = extractApiErrorMessage(error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', `Error al cargar votaciones: ${message}`)
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    },
    countVotes (item, value) {
      return Object.values(item.votos).filter(v => v === value).length
    },
    pct (item, value) {
      const total = Object.keys(item.votos).length || 1
      return (this.countVotes(item, value) / total) * 100
    },
    openDetail (item) {
      this.selected = item
      this.dialog = true
    },
    async cerrarVotacion () {
      try {
        const votacionActualizada = await votacionesService.cerrarVotacion(this.selected.id)
        this.selected = votacionActualizada

        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', `Votación cerrada — ${this.selected.estado}`)
        this.$store.commit('snackbar_activate_true')

        await this.loadVotaciones()
      } catch (error) {
        const message = extractApiErrorMessage(error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', `Error al cerrar votación: ${message}`)
        this.$store.commit('snackbar_activate_true')
      }
    },
    async crearVotacion () {
      if (!this.newVotacion.tema || !this.newVotacion.fechaCierre) {
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', 'Por favor completa los campos requeridos')
        this.$store.commit('snackbar_activate_true')
        return
      }

      this.loadingCreate = true
      try {
        const votacionCreada = await votacionesService.createVotacion(this.newVotacion)

        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', 'Votación creada exitosamente')
        this.$store.commit('snackbar_activate_true')

        this.dialogCreate = false
        this.newVotacion = { tema: '', descripcion: '', fechaCierre: '' }

        this.votaciones.unshift(votacionCreada)

        await this.loadVotaciones()
      } catch (error) {
        const message = extractApiErrorMessage(error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', `Error al crear votación: ${message}`)
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loadingCreate = false
      }
    }
  }
}
</script>

<style scoped>
.vote-progress {
  display: flex;
  height: 9px;
  border-radius: 5px;
  overflow: hidden;
  background: #EEEEEE;
  width: 180px;
}
.vote-seg { height: 100%; }
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 auto 4px;
}
</style>
